import { render, staticRenderFns } from "./EditLesson.vue?vue&type=template&id=52739c8a&scoped=true&"
import script from "./EditLesson.vue?vue&type=script&lang=js&"
export * from "./EditLesson.vue?vue&type=script&lang=js&"
import style0 from "./EditLesson.vue?vue&type=style&index=0&id=52739c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52739c8a",
  null
  
)

export default component.exports